// extracted by mini-css-extract-plugin
export var errorIcon = "_n4-1";
export var nameLogo = "_n4-0";